import { AddDriverRequestBuilder } from "client-sdk/src/entrances/newDriver";
import { Entrance } from "client-sdk/src/entrances/interface";
import handleError from "../../../utils/handleError";
import Client from "client-sdk/src/client";

const token = localStorage.getItem("token");

export async function addNewDriver(entranceData: Entrance) {
  try {
    const addNewDriverEntrance = new AddDriverRequestBuilder().data(
      entranceData,
    ).build();
    const client = new Client(token as string);
    const response = client.execute(addNewDriverEntrance);
    return response;
  } catch (error) {
    handleError(error.response);
  }
}

export default addNewDriver;
